import { useState } from "react";
import { Search, Sparkles } from "lucide-react";
import { fmtDur } from "@/components/shally/ui";

const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

function Hl({ text, q }) {
  if (!q) return text;
  return text.split(new RegExp(`(${esc(q)})`, "ig")).map((p, i) => (p.toLowerCase() === q.toLowerCase()
    ? <mark key={i} className="rounded bg-amber-200/70 px-0.5 text-foreground dark:bg-amber-400/30">{p}</mark> : p));
}

export function Transcript({ t }) {
  const [q, setQ] = useState("");
  if (!t) return <p className="text-sm text-muted-foreground" data-testid="ci-transcript-none">No transcript for this call.</p>;
  if (t.status !== "available") return <p className="text-sm text-muted-foreground" data-testid="ci-transcript-status">Transcript {t.status === "processing" || t.status === "pending" ? "is being prepared…" : t.status}.</p>;
  const qq = q.trim();
  const segs = (t.segments || []).filter((s) => !qq || s.text.toLowerCase().includes(qq.toLowerCase()));
  return (
    <div data-testid="ci-transcript">
      <p className="mb-3 flex items-start gap-1.5 text-xs text-muted-foreground"><Sparkles className="mt-0.5 h-3.5 w-3.5 shrink-0 text-primary" />
        AI-generated transcript ({t.model}). Speakers come from separate audio tracks and may contain errors.</p>
      <div className="relative mb-3">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
        <input data-testid="ci-transcript-search" placeholder="Search transcript" value={q} onChange={(e) => setQ(e.target.value)}
          className="h-9 w-full rounded-lg border border-border bg-card pl-8 pr-3 text-sm text-foreground focus:outline-none focus:ring-2 focus:ring-ring/30" />
      </div>
      {qq && <p className="mb-2 text-xs text-muted-foreground" data-testid="ci-transcript-matches">{segs.length} matching line{segs.length === 1 ? "" : "s"}</p>}
      <div className="max-h-96 space-y-2.5 overflow-y-auto pr-1">
        {segs.map((s, i) => {
          const sh = s.speaker === "shally";
          return (
            <div key={i} className={`flex ${sh ? "justify-end" : "justify-start"}`} data-testid={`ci-seg-${i}`}>
              <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 text-sm ${sh ? "rounded-tr-md bg-accent text-foreground" : "rounded-tl-md bg-muted text-foreground"}`}>
                <p className="mb-0.5 flex items-center gap-2 text-[11px] font-semibold text-muted-foreground">
                  <span className={sh ? "text-accent-foreground" : ""}>{sh ? "Shally" : "Customer"}</span><span className="font-mono font-normal">{fmtDur(Math.round(s.start))}</span></p>
                <p className="leading-relaxed"><Hl text={s.text} q={qq} /></p>
              </div>
            </div>);
        })}
        {qq && !segs.length && <p className="py-4 text-center text-sm text-muted-foreground" data-testid="ci-transcript-nomatch">No lines match “{qq}”.</p>}
      </div>
    </div>);
}
